import { formatCookieString } from '../cookies'
import { type AccountData } from '../models'

export const WEB_COOKIE_ORDER: string[] = [
  'sessionid', 'ds_user_id', 'rur', 'mid',
  'csrftoken', 'datr', 'ig_did', 'ig_nrcb', 'wd',
]

function isMobileAppUa(ua: string): boolean {
  return ua.startsWith('Instagram ')
}

export function formatWeb(account: AccountData): string {
  const ua = !account.userAgent || isMobileAppUa(account.userAgent)
    ? ''
    : account.userAgent
  const cookies: Record<string, string> = {}
  for (const [k, v] of Object.entries(account.cookies)) {
    if (k !== 'Authorization') cookies[k] = v
  }
  const cookieStr = formatCookieString(cookies, WEB_COOKIE_ORDER, true)
  const proxy = account.proxy || ''
  return `${account.login}:${account.password}:${account.twofaKey}|${ua}|${cookieStr}|${proxy}|`
}
